﻿{
    "ai-apps": {
        "tenantPromptMenu": "Invite du locataire",
        "mcpServersMenu": "Serveurs MCP",
        "menu": "App Builder",
        "list": {
            "title": "Applications",
            "name": "Nom de l'application",
            "createApp": "Créer une nouvelle application",
            "deletedSuccessfully": "Application supprimée avec succès",
            "noAppsFound": "Aucune application trouvée",
            "noPublishedVersion": "Aucune version publiée",
            "publishedBy": "par {name}",
            "versionsCount": "• {count} versions",
            "updatedAt": "Mis à jour {time}",
            "startApp": "Démarrer l'application",
            "runPublishedVersion": "Exécuter la version publiée",
            "editApp": "Modifier la dernière version",
            "continueEditingVersion": "Continuer à modifier v{version}",
            "copyApp": "Copier l'application",
            "copyAppSubtitle": "Créer une copie de cette application",
            "deleteApp": "Supprimer l'application",
            "deleteAppSubtitle": "Supprimer définitivement cette application",
            "rowsPerPage": "Lignes par page",
            "showAll": "Tout"
        },
        "nameAndDescription": "Général",
        "buildTitle": "Assistant IA",
        "dropSession": "Ignorer",
        "dropSessionConfirmation": "Êtes-vous sûr de vouloir supprimer la session de construction actuelle et ignorer tous les fichiers générés et la conversation ?",
        "saveSession": "Enregistrer",
        "saveAndContinue": "Enregistrer et continuer à construire",
        "saveAndExit": "Enregistrer et quitter le mode construction",
        "applySessionConfirmation": "Êtes-vous sûr de vouloir enregistrer les résultats de la session de construction actuelle ?",
        "sessionConflict": "Un autre utilisateur modifie actuellement cette version",
        "sessionConflictDetail": "Un seul utilisateur peut travailler sur une version à la fois. Veuillez réessayer plus tard.",
        "sessionConflictSuggestion": "Vous pouvez sélectionner une autre version ou attendre que la session actuelle soit terminée.",
        "sessionStartError": "Échec du démarrage de la session de construction",
        "undoLastPrompt": "Annuler le dernier prompt",
        "undoLastPromptFailed": "Échec de l'annulation du dernier prompt",
        "stopGenerating": "Arrêter la génération",
        "stopGeneratingFailed": "Échec de l'arrêt de la génération",
        "cancelled": "Annulé",
        "undone": "Annulé (défait)",
        "applicationLabels": "Étiquettes d’application",
        "labels": "Étiquettes",
        "description": "Description",
        "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer l'application suivante : {name}",
        "copy": "Copier",
        "copyApplication": "Copier l'application",
        "copyOfName": "Copie de {name}",
        "copyFromVersion": "Copier depuis la version",
        "applicationCopied": "Application copiée avec succès",
        "selectTables": "Tables",
        "name": "Nom",
        "connection": "Connexion",
        "vinceAi": "Vince AI",
        "usage": "Utilisation",
        "cost": "Coût",
        "tenantUsageTitle": "Utilisation des applications IA",
        "applicationUsageTitle": "Utilisation de {name}",
        "versionUsageTitle": "Utilisation de la version {version}",
        "usageLoadError": "Impossible de charger l’utilisation.",
        "vinceAiMcpUnsupported": "Vince AI ne prend actuellement pas en charge les ressources de serveur MCP. Sélectionnez une connexion du tenant ou supprimez les serveurs MCP.",
        "selectWorkflows": "Flux de travail",
        "summary": "Résumé",
        "publishedColumn": "Publié",
        "stateHeader": "Statut",
        "createdBy": "Créé par",
        "modifiedBy": "Modifié par",
        "created": "Créé par {name} le {date}",
        "newApplication": "Créer une nouvelle application",
        "customTablesSelected": "{selectedCount} tables personnalisées sélectionnées.",
        "workflowsSelected": "{selectedCount} flux de travail sélectionnés.",
        "selectMcpServers": "Serveurs MCP",
        "mcpServersSelected": "{selectedCount} serveurs MCP sélectionnés.",
        "summaryHeader": "Résumé de l'application",
        "resourceAliases": "Remplacer les alias de ressource",
        "absentResource": "Ressource introuvable",
        "customAlias": "Alias",
        "state": {
            "DRAFT": "Brouillon",
            "PUBLISHED": "Publié",
            "ARCHIVED": "Archivé"
        },
        "run": "Démarrer",
        "currentVersion": "Version",
        "publishedVersionTooltip": "Version publiée - par {name}",
        "createdVersions": "Versions créées",
        "backToList": "Retour à la liste",
        "back": "Retour",
        "Version": "Version",
        "archive": "Archiver",
        "publish": "Publier",
        "selectedVersion": "Version sélectionnée",
        "ver": "ver. ",
        "startBuildSession": "Construire",
        "editVersionInfo": "Notes",
        "createNewVersion": "Créer une nouvelle version",
        "archiveVersion": "Archiver",
        "resources": "Ressources",
        "viewResources": "Ressources",
        "versionResourcesLabel": "Ressources pour la nouvelle version",
        "versionRolesLabel": "Rôles pour la nouvelle version",
        "copyVersionRoles": "Copier les rôles de la version {versionNumber}",
        "specifyNewRoles": "Créer de nouveaux rôles",
        "specifyRolesAssignments": "Assigner des principaux à partir de zéro",
        "copyRolesAssignments": "Copier les assignations de rôles de la version {versionNumber}",
        "specifyNewResources": "Spécifier de nouvelles ressources",
        "versionAssets": "Ressources pour la nouvelle version",
        "copyVersionResources": "Copier les ressources de la version {versionNumber}",
        "copyVersionAssets": "Copier les actifs de la version {versionNumber}",
        "generateFromScratch": "Générer à partir de zéro",
        "resourcesNamesAreNotUnique": "Les noms de ressources doivent être uniques",
        "editApplicationInfo": "Modifier les informations",
        "publishVersion": "Publier",
        "updateVersionDescription": "Mettre à jour la description",
        "editVersionTitle": "Ajouter une note",
        "updateVersionNotes": "Mettre à jour les notes",
        "archiveVersionTitle": "Archiver la version",
        "publishVersionTitle": "Publier la version",
        "setAsDraftVersionTitle": "Convertir en brouillon",
        "newVersion": "Nouvelle version",
        "versionResources": "Ressources disponibles pour l'application",
        "resourceNaming": "Noms des ressources",
        "simpleM3Workflow": "Flux de travail M3 simple",
        "resourcesUpdated": "Ressources mises à jour avec succès",
        "changelog": "Historique des versions",
        "changelogTitle": "Versions de l'application",
        "versionUpdated": "Informations de version mises à jour",
        "versionCreated": "Nouvelle version créée avec succès",
        "isFavourite": "Votre application favorite. Cliquez pour retirer des favoris",
        "isNotFavourite": "Cliquez pour marquer comme application favorite",
        "copiedVersionDescription": "Description pour la nouvelle version",
        "messageSendFailed": "Échec de l'envoi du message. Veuillez réessayer.",
        "messageError": "Erreur",
        "waitingForResponse": "En attente de réponse...",
        "typeYourMessage": "Tapez votre message...",
        "loadingConversation": "Chargement de la conversation...",
        "loadingVersionInfo": "Chargement des informations de version...",
        "imageUploadFailed": "Échec du téléchargement de l'image : {filename}",
        "attachFiles": "Joindre des fichiers ({allowed})",
        "dropFilesHere": "Déposez des fichiers pour les joindre",
        "removeAttachment": "Supprimer {name}",
        "removeFile": "Supprimer le fichier",
        "attachmentsSummary": "{count} / {max} fichiers ({size} max chacun)",
        "attachmentTypeNotAllowed": "Le type du fichier « {name} » n'est pas autorisé. Types autorisés : {allowed}",
        "maxAttachmentsReached": "Maximum {max} fichiers autorisés par message",
        "attachmentEmpty": "Le fichier « {name} » est vide",
        "attachmentReadFailed": "Le fichier « {name} » n'a pas pu être lu",
        "attachmentTooLarge": "Le fichier « {name} » dépasse la limite de {max}",
        "attachmentsTotalTooLarge": "Les pièces jointes dépassent la limite totale de {max} par message",
        "attachmentContentMismatch": "Le fichier « {name} » ne correspond pas à son type. Types autorisés : {allowed}",
        "clickBuildToBuild": "Cliquez sur Construire pour commencer à créer l'application...",
        "unsavedWorkAlert": "Vous avez des modifications non enregistrées. Appuyez sur Enregistrer pour sauvegarder votre progression.",
        "unsavedWorkLeaveMessage": "Vous avez une session de construction active avec des modifications non enregistrées. Si vous partez, votre progression sera perdue. Êtes-vous sûr de vouloir continuer ?",
        "providedAppsCanBeRunDirectly": "Les applications fournies peuvent être exécutées directement depuis la liste.",
        "labelsFilterSelected": "étiquettes sélectionnées",
        "users": "Utilisateurs",
        "usersFilterSelected": "utilisateurs sélectionnés",
        "createdOrEditedBy": "Créé ou modifié par",
        "preview": {
            "appBridgeLogs": "Journal de pont {logsCount}",
            "noPreviewAvailable": "Aucun aperçu disponible",
            "askAiToGenerate": "Rien à afficher pour l'instant, ajoutez une invite pour commencer à construire",
            "compilationFailed": "Échec de la compilation",
            "compiling": "Compilation...",
            "loading": "Chargement de l'aperçu...",
            "loadFailed": "Échec du chargement de l'aperçu",
            "clearLogs": "Effacer les journaux",
            "invocationLogs": "Journaux de pont d'application"
        },
        "invocationAction": {
            "REQUEST_RECEIVED": "Requête de l'application : ",
            "RESPONSE_RETURNED": "Réponse à l'application ",
            "ERROR": "Erreur survenue ",
            "INIT": "Pont initialisé"
        },
        "startingApplication": "Démarrage de l'application. Veuillez patienter...",
        "providedSourceUrl": "URL d'index pour l'application fournie",
        "applicationType": {
            "GENERATED": "Généré",
            "PROVIDED": "Fourni"
        },
        "applicationTypeLabel": "Type d'application",
        "minimize": "Réduire",
        "toggleFullScreen": "Plein écran",
        "resource": {
            "app": "Application",
            "mcpServer": "Serveur MCP",
            "tenantPrompt": "Invite du locataire",
            "mcpToolPermission": "Autorisation d'outil MCP"
        },
        "seconds": "s",
        "noMessagesYet": "Pas encore de messages",
        "generatedAssets": "Actifs générés",
        "assetsListTitle": "Liste des actifs",
        "selectAsset": "Sélectionner un actif pour voir les détails",
        "showAssets": "Actifs",
        "noStartUrlProvided": "Impossible de déterminer l'URL de démarrage pour l'application",
        "refresh": "Actualiser",
        "cannotEditInfoOfAppWithBuildSession": "Impossible de modifier les informations de version avec une session de construction active",
        "cannotShowOfAppWithBuildSession": "Impossible d'afficher les actifs avec une session de construction active - les actifs seront disponibles après la fin de la session de construction",
        "cannotArchiveVersionWithBuildSession": "Impossible d'archiver la version avec une session de construction active. Appliquez ou abandonnez d'abord la session de construction actuelle",
        "cannotPublishVersionWithBuildSession": "Impossible de publier la version avec une session de construction active. Appliquez ou abandonnez d'abord la session de construction actuelle",
        "cannotEditResourcesWithBuildSession": "Avec une session de construction active, il est possible uniquement de consulter les ressources",
        "cannotEditRolesWithBuildSession": "Impossible de modifier les rôles intégrés avec une session de construction active. Appliquez ou abandonnez d'abord la session de construction actuelle",
        "tenantPrompt": {
            "title": "Invite du locataire",
            "subtitle": "Invite qui sera automatiquement ajoutée dans le cadre du prompt système à toutes les conversations avec votre assistant IA."
        },
        "principalType": {
            "USER": "Utilisateur",
            "ROLE": "Rôle"
        },
        "selectUsers": "Sélectionner des utilisateurs",
        "assignments": "Assignations de rôles intégrés : ",
        "simulateRoles": "Simuler des rôles",
        "roleNotAssigned": "Le rôle n'a pas de principaux assignés",
        "addAssignments": "Ajouter des assignations",
        "rolesSelected": "{selectedCount} rôles sélectionnés.",
        "usersSelected": "{selectedCount} utilisateurs sélectionnés.",
        "selectRoles": "Sélectionner des rôles",
        "rolesMenu": "Rôles intégrés",
        "rolesListTitle": "Rôles",
        "deleteRoleSuccess": "Rôle intégré supprimé avec succès",
        "editRole": "Modifier le rôle intégré",
        "roleName": "Nom/identifiant du rôle",
        "roleNameHint": "Essayez d'utiliser un nom court et descriptif",
        "dangerToChangeRole": "Changer le nom/identifiant du rôle peut casser l'application existante. Changez uniquement si vous êtes sûr que l'application n'utilise pas ce rôle.",
        "deleteRoleConfirmation": "Êtes-vous absolument sûr de vouloir supprimer le rôle : {role} ? Toutes les assignations de rôles seront également supprimées et des parties de l'application peuvent devenir inutilisables sans elle.",
        "selectRole": "Sélectionner un rôle pour voir les assignations",
        "selectSession": "Sélectionner une session de construction pour voir l'invite",
        "sessionsTitle": "Sessions de construction",
        "noBuildSessions": "Aucune session de construction terminée pour l'instant",
        "showBuildPrompt": "Invite de construction",
        "feedbackMenu": "Commentaires",
        "feedbackTitle": "Commentaires sur l'application",
        "showRead": "Afficher les lus",
        "thisVersionOnly": "Cette version uniquement",
        "noFeedback": "Aucun commentaire pour l'instant",
        "markAsRead": "Marquer comme lu",
        "feedbackMarkedRead": "Commentaire marqué comme lu",
        "read": "Lu",
        "feedbackSubmitted": "Par {name} le {date}",
        "feedbackComment": "Commentaire",
        "feedbackBy": "Soumis par",
        "feedbackDate": "Date",
        "feedbackStatus": "Statut",
        "mcpServers": {
            "title": "Serveurs MCP",
            "create": "Ajouter un serveur MCP",
            "createTitle": "Ajouter un serveur MCP",
            "editTitle": "Modifier le serveur MCP",
            "name": "Nom",
            "nameHint": "Identifiant machine utilisé comme nom de connecteur. Doit respecter le jeu de caractères autorisé.",
            "namePatternError": "Le nom ne peut contenir que des lettres, des chiffres, des traits de soulignement et des tirets (1-128 caractères).",
            "systemPrompt": "Invite système",
            "systemPromptHint": "Fragment d'invite facultatif décrivant les outils du serveur à l'assistant de création d'application.",
            "config": "Modèle de configuration",
            "configHint": "Modèle JSONata/VinceLiveMorph qui doit s'évaluer en un objet {props}. Exemple :",
            "configVariables": "Variables disponibles (directement et sous $context) : $authToken, $userId, $email. Les variables JSONata sont sans guillemets. url doit être une chaîne non vide.",
            "noServersFound": "Aucun serveur MCP configuré pour le moment",
            "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer le serveur MCP : {name} ?",
            "deleted": "Serveur MCP supprimé avec succès",
            "created": "Serveur MCP créé avec succès",
            "updated": "Serveur MCP mis à jour avec succès",
            "testConnection": "Tester la connexion",
            "probeReachable": "Serveur accessible",
            "probeNoTools": "Serveur accessible, aucun outil exposé",
            "probeFailed": "Échec de la connexion"
        },
        "devicePicker": {
            "deleted": "Appareil supprimé avec succès",
            "DESKTOP": "Bureau",
            "TABLET": "Tablette",
            "HANDHELD": "Mobile",
            "addCustom": "Ajouter un personnalisé",
            "customDefault": "Personnalisé",
            "responsivePreview": "Mode aperçu responsive",
            "rotate": "Faire pivoter la fenêtre d'affichage"
        },
        "serviceStatus": {
            "minor": "Les fonctionnalités IA peuvent être légèrement plus lentes que d'habitude.",
            "major": "Les fonctionnalités IA sont actuellement perturbées — des réponses lentes sont à prévoir.",
            "critical": "Le service IA est actuellement indisponible."
        },
        "claudeStatus": {
            "tooltip": "Claude : {status}. Dernière vérification : {time}. Cliquez pour plus de détails.",
            "notChecked": "pas encore vérifié",
            "status": {
                "unknown": "Statut indisponible",
                "operational": "Opérationnel",
                "degraded": "Performances dégradées",
                "partial_outage": "Panne partielle",
                "major_outage": "Panne majeure",
                "maintenance": "En maintenance"
            }
        }
    }
}
